import * as types from '../constants'
import _ from 'lodash'
const initState = {
}

export default function(state = initState, action) {
    switch (action.type) {
        case types.GET_USER_INF:
          state = action.payload
        return _.cloneDeep(state)
        break;
        default:
        return state;
    }
}
